<template>
  <div
    :key="pageKey"
    class="commune-page-container"
  >
    <SBackButton />
    <h1 class="heading-3 mb-2 mt-6">
      {{ title }}
    </h1>
    <div class="subtitle-3 textSecondary--text mb-6">
      {{ subTitle }}
    </div>
    <VueMarkdown
      v-if="description"
      class="body-2 mb-9"
    >
      {{ description }}
    </VueMarkdown>
    <VRow>
      <VCol>
        <VueMarkdown
          v-if="contactCommune"
          class="body-2"
        >
          {{ contactCommune }}
        </VueMarkdown>
      </VCol>
      <VCol>
        <VueMarkdown
          v-if="opening"
          class="body-2"
        >
          {{ opening }}
        </VueMarkdown>
      </VCol>
    </VRow>
  </div>
</template>

<script lang="ts">
import { getMetaInfo } from '@/utils/seo';

export default {
  name: 'CommunePage',
  metaInfo() {
    return getMetaInfo((this as { seo?: unknown }).seo);
  },
};
</script>

<script setup lang="ts">
import { ref } from 'vue';
import { getCommuneBySlug } from '@/services/cmsService';
import { SBackButton } from '@slg/web-customer-shared';
import VueMarkdown from 'vue-markdown';
import { useStore, useRouteRef, useCmsLocaleReload } from '@/composables';

const store = useStore();
const route = useRouteRef();
const title = ref('');
const description = ref('');
const pageKey = ref(new Date().toString());
const contactCommune = ref('');
const opening = ref('');
const seo = ref<any>('');
const subTitle = ref('');
const cmsData = ref(null);

async function loadCmsData() {
  store.commit('common/setGlobalLoading', true);
  try {
    const slug = route.value.params.name as string;
    const data = await getCommuneBySlug(slug) as any;
    seo.value = data?.Seo || '';
    title.value = data?.Title || '';
    subTitle.value = data?.Subtitle || '';
    description.value = data?.Description || '';
    opening.value = data?.Opening || '';
    contactCommune.value = data?.ContactCommune || '';
    pageKey.value = new Date().toString();
    seo.value = data?.Seo || '';
  } catch (error) {
    cmsData.value = null;
  } finally {
    store.commit('common/setGlobalLoading', false);
  }
}

useCmsLocaleReload(loadCmsData);
</script>

<style lang="scss">
.commune-page-container {
  margin: 0 10%;
  padding: 30px;
  padding-top: 80px;
  min-height: 400px;
}
</style>
